import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { usePricingContext } from '@spotahome/marketplace-common/src/context/PricingContext';

import BookingBar from './BookingBar';

const MobileBookNow = ({
  countryCode,
  landlordPolicies,
  pricing,
  moveIn = '',
  moveOut = '',
  onClick,
  showPrice = true,
  isBookable,
  hasRentCollection = false
}) => {
  const pricingContext = usePricingContext();

  const button = {
    onClick,
    label:
      moveIn && moveOut
        ? trans('property_show.book_now_card.request')
        : trans('property_show.book_now_button.check-availabilities')
  };

  return (
    <BookingBar
      countryCode={countryCode}
      landlordPolicies={landlordPolicies}
      moveIn={moveIn}
      moveOut={moveOut}
      className={'listing__booking-bar'}
      price={{
        monthly: !pricingContext.isWeekly,
        currencyCode: pricing.currencyLabel,
        amount: pricing
      }}
      button={button}
      showPrice={showPrice}
      isBookable={isBookable}
      hasRentCollection={hasRentCollection}
    />
  );
};

MobileBookNow.propTypes = {
  onClick: PropTypes.func.isRequired,
  pricing: PropTypes.shape({
    currencyLabel: PropTypes.string
  }).isRequired,
  moveIn: PropTypes.string,
  moveOut: PropTypes.string,
  showPrice: PropTypes.bool,
  countryCode: PropTypes.string.isRequired,
  landlordPolicies: PropTypes.string.isRequired,
  isBookable: PropTypes.bool.isRequired,
  hasRentCollection: PropTypes.bool
};

export default MobileBookNow;
